"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaPreview = void 0;
const react_1 = __importDefault(require("react"));
const helpers = __importStar(require("../helpers"));
function SchemaPreview(props) {
    const schema = helpers.exportSchema(props.columns, props.metadata);
    const schemaAsText = JSON.stringify(schema, null, 2);
    return (react_1.default.createElement("div", { className: "tableschema-ui-editor-preview" },
        react_1.default.createElement("pre", null,
            react_1.default.createElement("code", null, schemaAsText))));
}
exports.SchemaPreview = SchemaPreview;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2NoZW1hUHJldmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NjaGVtYVByZXZpZXcudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsa0RBQXlCO0FBRXpCLG9EQUFxQztBQU9yQyxTQUFnQixhQUFhLENBQUMsS0FBMEI7SUFDdEQsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQTtJQUNsRSxNQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDcEQsT0FBTyxDQUNMLHVDQUFLLFNBQVMsRUFBQywrQkFBK0I7UUFDNUM7WUFDRSw0Q0FBTyxZQUFZLENBQVEsQ0FDdkIsQ0FDRixDQUNQLENBQUE7QUFDSCxDQUFDO0FBVkQsc0NBVUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBJRGljdCB9IGZyb20gJy4uL2NvbW1vbidcbmltcG9ydCAqIGFzIGhlbHBlcnMgZnJvbSAnLi4vaGVscGVycydcblxuZXhwb3J0IGludGVyZmFjZSBJU2NoZW1hUHJldmlld1Byb3BzIHtcbiAgY29sdW1uczogSURpY3RbXVxuICBtZXRhZGF0YTogSURpY3Rcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIFNjaGVtYVByZXZpZXcocHJvcHM6IElTY2hlbWFQcmV2aWV3UHJvcHMpIHtcbiAgY29uc3Qgc2NoZW1hID0gaGVscGVycy5leHBvcnRTY2hlbWEocHJvcHMuY29sdW1ucywgcHJvcHMubWV0YWRhdGEpXG4gIGNvbnN0IHNjaGVtYUFzVGV4dCA9IEpTT04uc3RyaW5naWZ5KHNjaGVtYSwgbnVsbCwgMilcbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT1cInRhYmxlc2NoZW1hLXVpLWVkaXRvci1wcmV2aWV3XCI+XG4gICAgICA8cHJlPlxuICAgICAgICA8Y29kZT57c2NoZW1hQXNUZXh0fTwvY29kZT5cbiAgICAgIDwvcHJlPlxuICAgIDwvZGl2PlxuICApXG59XG4iXX0=